// Steps/NotificationContent.js - Step 4 Component
import { useContext, useEffect } from 'react';
import { NotificationDataContext } from '../AddEditNotification';
import PushMessageContent from './MessageContent/PushMessageContent';
import TextMessageContent from './MessageContent/TextMessageContent';
import EmailMessageContent from './MessageContent/EmailMessageContent';
import WhatsappMessageContent from './MessageContent/WhatsappMessageContent';

const NotificationContent = () => {
    const { notificationData, setNotificationData } = useContext(NotificationDataContext);
    
    // Clear data for modes that are no longer selected when entering this step
    useEffect(() => {
        const currentModes = notificationData.deliveryModes || [];
        let shouldUpdate = false;
        const updates = {};
        
        // Check each delivery mode and clear data if mode is not selected
        if (!currentModes.includes('whatsapp') && notificationData.whatsappData && Object.keys(notificationData.whatsappData).length > 0) {
            console.log('Clearing WhatsApp data - mode not selected');
            updates.whatsappData = {};
            shouldUpdate = true;
        }
        
        // Add similar checks for other modes as needed
        // if (!currentModes.includes('sms') && notificationData.smsData) {
        //     updates.smsData = {};
        //     shouldUpdate = true;
        // }
        
        if (shouldUpdate) {
            setNotificationData(prev => ({
                ...prev,
                ...updates
            }));
        }
    }, []); // Run only once when component mounts
    
    return (
        <>
            {notificationData.deliveryModes.includes('push') && <PushMessageContent />}
            {notificationData.deliveryModes.includes('sms') && <TextMessageContent />}
            {notificationData.deliveryModes.includes('email') && <EmailMessageContent />}
            {notificationData.deliveryModes.includes('whatsapp') && <WhatsappMessageContent />}
        </>
    );
};

export default NotificationContent;